import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToolbox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="toolbox"><path d="M2.75 10.75H21.25V20.25H2.75V10.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 10.75V2.75H19.25V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 6.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 10.75V6L6.5 2.75H7.5L9.25 6V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconToolbox;
